import { render } from "./KeywordMix.vue?vue&type=template&id=042a53ae"
import script from "./KeywordMix.vue?vue&type=script&lang=js"
export * from "./KeywordMix.vue?vue&type=script&lang=js"

import "./KeywordMix.vue?vue&type=style&index=0&id=042a53ae&lang=css"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__